// extracted by mini-css-extract-plugin
export default {"type":"DonationFrequency_type__IWB8X","selected":"DonationFrequency_selected__261p2","unselected":"DonationFrequency_unselected__q3uPs"};